// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"46644f9c","239":"42f410e6","453":"d6742cd4","667":"1df9e579"}[chunkId] + ".chunk.js";
};